import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <section className="page legal-page">
      <h1>Privacy Policy</h1>
      <p className="last-updated">Last updated: December 5, 2025</p>

      <h2>1. Introduction</h2>
      <p>
        IQTechnologies ("we," "our," or "us") operates the IQLedger platform and related services. 
        This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
        when you use our services.
      </p>

      <h2>2. Information We Collect</h2>
      <h3>Account Information</h3>
      <p>
        When you create an account, we collect your email address, name, and authentication 
        credentials through our authentication provider (Clerk). We also collect billing 
        information through our payment processor (Stripe).
      </p>

      <h3>Log Data</h3>
      <p>
        IQLedger is designed to store AI/LLM interaction logs that you send to our platform. 
        This data is stored securely and is only accessible by authorized members of your 
        organization. We apply automatic PII redaction to help protect sensitive information.
      </p>

      <h3>Usage Data</h3>
      <p>
        We automatically collect certain information when you access our services, including 
        your IP address, browser type, operating system, and usage patterns within our platform.
      </p>

      <h2>3. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide, maintain, and improve our services</li>
        <li>Process transactions and send related information</li>
        <li>Send technical notices, updates, and security alerts</li>
        <li>Respond to your comments, questions, and support requests</li>
        <li>Monitor and analyze trends, usage, and activities</li>
        <li>Detect, investigate, and prevent fraudulent or unauthorized activities</li>
      </ul>

      <h2>4. Data Security</h2>
      <p>
        We implement appropriate technical and organizational measures to protect your data, 
        including encryption at rest and in transit, access controls, and regular security 
        assessments. Your log data is stored in secure, SOC 2 compliant infrastructure.
      </p>

      <h2>5. Data Retention</h2>
      <p>
        We retain your log data according to your plan's retention policy (30, 90, or 365 days). 
        Account information is retained for as long as your account is active. You can request 
        deletion of your account and associated data at any time.
      </p>

      <h2>6. Third-Party Services</h2>
      <p>We use the following third-party services:</p>
      <ul>
        <li><strong>Clerk</strong> – Authentication and user management</li>
        <li><strong>Stripe</strong> – Payment processing</li>
        <li><strong>Render</strong> – Cloud infrastructure hosting</li>
        <li><strong>Neon</strong> – Database hosting</li>
      </ul>
      <p>
        Each of these providers has their own privacy policies governing their use of your data.
      </p>

      <h2>7. Your Rights</h2>
      <p>Depending on your location, you may have the right to:</p>
      <ul>
        <li>Access the personal data we hold about you</li>
        <li>Request correction of inaccurate data</li>
        <li>Request deletion of your data</li>
        <li>Object to or restrict certain processing</li>
        <li>Data portability</li>
      </ul>
      <p>
        To exercise these rights, please contact us at <a href="mailto:privacy@iqtechnologies.ai">privacy@iqtechnologies.ai</a>.
      </p>

      <h2>8. International Data Transfers</h2>
      <p>
        Your information may be transferred to and processed in countries other than your own. 
        We ensure appropriate safeguards are in place for such transfers in compliance with 
        applicable data protection laws.
      </p>

      <h2>9. Children's Privacy</h2>
      <p>
        Our services are not intended for individuals under the age of 18. We do not knowingly 
        collect personal information from children.
      </p>

      <h2>10. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. We will notify you of any changes 
        by posting the new policy on this page and updating the "Last updated" date.
      </p>

      <h2>11. Contact Us</h2>
      <p>
        If you have questions about this Privacy Policy, please contact us at:
      </p>
      <p>
        <a href="mailto:privacy@iqtechnologies.ai">privacy@iqtechnologies.ai</a>
      </p>
    </section>
  );
}

export default Privacy;
